import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { StoreAction } from 'store/actions';
import { OrderDetail, OrderStatus } from 'store/order/models';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';

@Injectable()
export class OrderApi {
    public static getOrderDetail(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<OrderDetail> {
        return http.get(`/orders/${params.orderId}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY }),
            params: { trialFeatures: 'TRIAL_EBP' }
        }).pipe(
            map((orderDetail: OrderDetail) => OrderDetail.create<OrderDetail>(orderDetail))
        );
    }

    public static deleteOrderDetail(_xmStore: XmStore, _http: HttpClient, params: ApiParams): Observable<OrderDetail> {
        return of(new OrderDetail(params));
    }

    public static cancelOrder(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<ApiResponse> {
        return http.post(`/orders/${params.orderId}/cancel`, {}, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY }),
            params: { runEligibility: 'true' }
        });
    }

    public static orderStatus(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<OrderStatus> {
        return http.get(`/orders/${params.orderId}/status`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((orderDetail: OrderStatus) => OrderStatus.create<OrderStatus>(orderDetail))
        );
    }
}

ModelBase.persistMapping[StoreAction.CANCEL_ORDER] = OrderApi.cancelOrder;
ModelBase.fetchMapping[StoreAction.GET_ORDER_DETAIL] = OrderApi.getOrderDetail;
ModelBase.deleteMapping[StoreAction.DELETE_ORDER_DETAIL] = OrderApi.deleteOrderDetail;
ModelBase.fetchMapping[StoreAction.ORDER_STATUS] = OrderApi.orderStatus;
